import notie from "notie";

export default {
	info(msg) {
		msg = `<span class="text-md">` + msg + `</span>`;
		this._alert(msg, "info");
	},

	success(msg, submsg) {
		msg = `<div class="text-md">${msg}</div>`;
		if (submsg) {
			msg += `<div class="text-muted">${submsg}</div>`
		}
		this._alert(msg, "success");
	},

	extractErrorMessage(err) {
		if (typeof err == "string") {
			return err;
		} else if (
			err &&
			err.response &&
			err.response.data &&
			err.response.data.data &&
			err.response.data.data.Err
		) {
			return err.response.data.data.Err;
		} else if (
			err &&
			err.response &&
			err.response.data &&
			err.response.data.message
		) {
			return err.response.data.message;
		} else if (
			err &&
			err.response &&
			err.response.data &&
			typeof err.response.data == "string"
		) {
			return err.response.data;
		} else if (err.message) {
			return `Client error: ${err.message}`;
		}
	},

	error(msg, err) {
		if (err && err.suppress) {
			return;
		}

		msg = `<span class="text-md">` + msg + `</span>`;

		var errMsg;
		if (err) {
			errMsg = this.extractErrorMessage(err);
		}
		if (errMsg) {
			msg = msg + `<br/><div class="text-muted text-xs">${errMsg}</div>`;
		}
		this._alert(msg, "error");
	},

	warning(msg) {
		this._alert(msg, "warning");
	},

	_alert(msg, type) {
		notie.alert({
			type: type,
			text: msg
		});
	}
};



// WEBPACK FOOTER //
// ./src/services/NotieService.js